import { render, staticRenderFns } from "./createInProject.vue?vue&type=template&id=1c9c5b9f&"
import script from "./createInProject.vue?vue&type=script&lang=js&"
export * from "./createInProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports